import { useEffect, useState } from "react";

const NAV_ITEMS = [
  { label: "Story", href: "#story" },
  { label: "Programme", href: "#programme" },
  { label: "Apply", href: "#apply" },
  { label: "Resources", href: "#resources" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-md border-b border-zinc-900"
          : "bg-transparent"
      }`}
      style={{ top: "var(--bar-h, 0px)" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="text-white font-extrabold tracking-tight text-base md:text-lg"
        >
          JORDAN<span className="text-zinc-500">.</span>YOUNG
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className="text-xs tracking-[0.2em] uppercase text-zinc-400 hover:text-white transition-colors duration-300"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#apply"
          data-testid="nav-apply-cta"
          className="hidden md:inline-flex items-center text-xs tracking-[0.2em] uppercase font-bold text-black bg-white px-5 py-3 hover:bg-zinc-200 transition-colors duration-300"
        >
          Apply
        </a>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-white"
        >
          <div className="space-y-1.5">
            <span
              className={`block h-px w-6 bg-white transition-transform duration-300 ${
                open ? "translate-y-1.5 rotate-45" : ""
              }`}
            />
            <span
              className={`block h-px w-6 bg-white transition-opacity duration-300 ${
                open ? "opacity-0" : "opacity-100"
              }`}
            />
            <span
              className={`block h-px w-6 bg-white transition-transform duration-300 ${
                open ? "-translate-y-1.5 -rotate-45" : ""
              }`}
            />
          </div>
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden border-t border-zinc-900 bg-black transition-[max-height] duration-500 ${
          open ? "max-h-96" : "max-h-0"
        }`}
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
              className="text-sm tracking-[0.2em] uppercase text-zinc-300 hover:text-white"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#apply"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-apply-cta"
            className="mt-2 inline-flex items-center justify-center text-xs tracking-[0.2em] uppercase font-bold text-black bg-white px-5 py-3"
          >
            Apply To Work Together
          </a>
        </div>
      </div>
    </header>
  );
};
